module.exports = __webpack_public_path__ + "img/黄精.d0215902.jpg";